module.exports = __webpack_public_path__ + "static/media/cc_icon-cup.feceb330.svg";